import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <nav className={`navbar ${isScrolled ? 'scrolled glass' : ''}`}>
            <div className="nav-container">
                <Link to="/" className="nav-logo" onClick={closeMenu}>
                    THE<span>IC</span>
                </Link>

                {/* Mobile Toggle Button */}
                <div className={`nav-toggle ${isMobileMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <ul className={`nav-links ${isMobileMenuOpen ? 'mobile-active glass' : ''}`}>
                    <li><Link to="/" onClick={closeMenu}>Home</Link></li>
                    <li><Link to="/about" onClick={closeMenu}>About</Link></li>
                    <li className="dropdown">
                        <Link to="/courses/physical-design">Courses</Link>
                        <ul className="dropdown-menu glass">
                            <li><Link to="/courses/physical-design" onClick={closeMenu}>Physical Design</Link></li>
                            <li><Link to="/courses/dft" onClick={closeMenu}>DFT</Link></li>
                        </ul>
                    </li>
                    <li><Link to="/contact" onClick={closeMenu}>Contact Us</Link></li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
